import React from 'react';
import { useState, useEffect } from 'react';
import '../styles/styles.css';
var Typing = function (_a) {
    var text = _a.text, speed = _a.speed, cursor = _a.cursor, textClassName = _a.textClassName, cursorClassName = _a.cursorClassName, repeat = _a.repeat;
    var _b = useState('forward'), step = _b[0], setStep = _b[1];
    var _c = useState(''), alphabet = _c[0], setAlphabet = _c[1];
    var _d = useState(0), index = _d[0], setIndex = _d[1];
    var _e = useState(0), wordIndex = _e[0], setWordIndex = _e[1];
    useEffect(function () {
        var interval = setInterval(function () {
            if (wordIndex < text.length) {
                if (step === 'forward') {
                    if (index < text[wordIndex].length) {
                        setAlphabet(function (prev) { return prev + text[wordIndex][index]; });
                        setIndex(function (prev) { return prev + 1; });
                    }
                    else {
                        if (wordIndex === text.length - 1 && index === text[wordIndex].length && !repeat) {
                            clearInterval(interval);
                            return;
                        }
                        setStep('backward');
                    }
                }
                else if (step === 'backward') {
                    if (index === 0) {
                        if (wordIndex === text.length - 1) {
                            setStep('forward');
                            setWordIndex(0);
                        }
                        else {
                            setStep('forward');
                            setWordIndex(function (prev) { return prev + 1; });
                        }
                    }
                    else {
                        setAlphabet(function (prev) { return prev.slice(0, prev.length - 1); });
                        setIndex(function (prev) { return prev - 1; });
                    }
                }
            }
        }, speed);
        return function () {
            clearInterval(interval);
        };
    }, [text, speed, index, repeat, step, wordIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: textClassName },
            alphabet,
            " ",
            React.createElement("span", { className: "".concat(cursorClassName, " fadeInAndOut") }, cursor))));
};
Typing.defaultProps = {
    text: [],
    speed: 500,
    cursor: '_',
    textClassName: '',
    cursorClassName: '',
    repeat: true,
    repeatValue: 0,
};
export default Typing;
//# sourceMappingURL=App.js.map